import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/app.js";
import "./styles/fonts.css";
import "./styles/tailwind.css";
import "./styles/visual-hierarchy.css";
import { scheduleServiceWorker } from "./pwa/pwa-startup.js";
import { installClientErrorReporting } from "./observability/report-client-error.js";
import { claimLinkTarget } from "./lib/invite-link.js";
import { initializeInstallDiscovery } from "./pwa/install-browser.js";

installClientErrorReporting();
initializeInstallDiscovery();
const claimTarget = claimLinkTarget(window.location.pathname);
if (claimTarget) window.history.replaceState(null, "", claimTarget);
scheduleServiceWorker();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
